// ----------------------------------------------------------------------------
// Template: Cart
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

//Scripts
import './ajax-cart-page';
import 'snippets/cart-js/cart-js';
import 'snippets/_containers/form/form-increment';

import 'sections/header/header';
import 'sections/footer/footer';

// Styles
import './_cart.scss';


// -------------------------------------
// Variables
// -------------------------------------

const ACCORDION                = '.js-cart__footer--accordion';
const ACCORDION_BUTTON         = '.js-cart-accordion__button';
const ACCORDION_ITEM           = '.js-cart-accordion__item';
const ACCORDION_CONTENT        = '.js-cart-accordion__content';

// Constant trigger classes
const OPEN_CLASS          = 'is-open';


// -------------------------------------
// Helper Functions
// -------------------------------------
function setTabIndex(e, value) {
    e.setAttribute('tabindex', value);
}

function openFirstAccordion(accordion) {
    if(accordion !== null) {
        accordion.querySelector(ACCORDION_BUTTON).classList.add(OPEN_CLASS);
        accordion.querySelector(ACCORDION_ITEM).classList.add(OPEN_CLASS);
        accordion.querySelector(ACCORDION_CONTENT).classList.add(OPEN_CLASS);
        accordion.querySelector(ACCORDION_CONTENT).style.height = 'auto';

        accordion.querySelector(ACCORDION_BUTTON).setAttribute('aria-expanded', 'true');
        accordion.querySelector(ACCORDION_CONTENT).hidden = false;
        accordion.querySelector(ACCORDION_CONTENT).querySelectorAll('a').forEach(function(el) {
            setTabIndex(el, 0);
        });
    }
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function() {
    const accordion = document.querySelector(ACCORDION);

    if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) && window.innerWidth >= 1024) {
        openFirstAccordion(accordion); // Code for desktop
    }
});

window.addEventListener('resize', function() {
    const accordion = document.querySelector(ACCORDION);

    if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) && window.innerWidth >= 1024) {
        openFirstAccordion(accordion); // Code for desktop
    }
});
